import { useEffect, useCallback } from 'react';
import { useAnuncioStore } from '../store/anuncioStore';
import { FiltrosAnuncio, AnuncioFormData } from '../types';
import anunciosService from '../services/anuncios';
import toast from 'react-hot-toast';

export function useAnuncios() {
  const store = useAnuncioStore();

  return {
    // State
    anuncios: store.anuncios,
    anuncioAtual: store.anuncioAtual,
    meusAnuncios: store.meusAnuncios,
    destaques: store.destaques,
    recentes: store.recentes,
    total: store.total,
    pagina: store.pagina,
    totalPaginas: store.totalPaginas,
    filtros: store.filtros,
    isLoading: store.isLoading,
    isLoadingMais: store.isLoadingMais,

    // Actions
    listarAnuncios: store.listarAnuncios,
    carregarMais: store.carregarMais,
    buscarAnuncio: store.buscarAnuncio,
    carregarMeusAnuncios: store.carregarMeusAnuncios,
    carregarDestaques: store.carregarDestaques,
    carregarRecentes: store.carregarRecentes,
    setFiltros: store.setFiltros,
    limparFiltros: store.limparFiltros,
    pausarAnuncio: store.pausarAnuncio,
    ativarAnuncio: store.ativarAnuncio,
    deletarAnuncio: store.deletarAnuncio,
    marcarVendido: store.marcarVendido,
  };
}

export function useFavoritos() {
  const store = useAnuncioStore();

  return {
    favoritos: store.favoritos,
    favoritosIds: store.favoritosIds,
    carregarFavoritos: store.carregarFavoritos,
    toggleFavorito: store.toggleFavorito,
    isFavorito: store.isFavorito,
  };
}

export function useChat() {
  const store = useAnuncioStore();

  return {
    conversas: store.conversas,
    conversaAtual: store.conversaAtual,
    mensagens: store.mensagens,
    isLoading: store.isLoading,
    carregarConversas: store.carregarConversas,
    selecionarConversa: store.selecionarConversa,
    carregarMensagens: store.carregarMensagens,
    enviarMensagem: store.enviarMensagem,
    iniciarConversa: store.iniciarConversa,
  };
}

export function useAnuncioForm() {
  const criarAnuncio = useCallback(async (data: AnuncioFormData) => {
    try {
      const anuncio = await anunciosService.criar(data);
      toast.success('Anúncio criado com sucesso!');
      return anuncio;
    } catch (error: any) {
      const message = error.response?.data?.message || 'Erro ao criar anúncio';
      toast.error(message);
      throw error;
    }
  }, []);

  const atualizarAnuncio = useCallback(async (id: string, data: Partial<AnuncioFormData>) => {
    try {
      const anuncio = await anunciosService.atualizar(id, data);
      toast.success('Anúncio atualizado com sucesso!');
      return anuncio;
    } catch (error: any) {
      const message = error.response?.data?.message || 'Erro ao atualizar anúncio';
      toast.error(message);
      throw error;
    }
  }, []);

  return {
    criarAnuncio,
    atualizarAnuncio,
  };
}

export function useDashboard() {
  const getDashboardStats = useCallback(async () => {
    try {
      return await anunciosService.getDashboardStats();
    } catch (error) {
      toast.error('Erro ao carregar estatísticas');
      throw error;
    }
  }, []);

  const getAdminStats = useCallback(async () => {
    try {
      return await anunciosService.getAdminStats();
    } catch (error) {
      toast.error('Erro ao carregar estatísticas');
      throw error;
    }
  }, []);

  return {
    getDashboardStats,
    getAdminStats,
  };
}

export default useAnuncios;
